/**
 * How a delivery outcome looks, shared by the incident sidecar and the delivery log.
 *
 * The *words* for each status come from the server (`statusLabel`), deliberately —
 * the router owns its own vocabulary and two surfaces re-implementing it is how
 * "skipped_muted" comes to mean two different things. What lives here is only the
 * visual weight, which the server has no opinion about.
 */

export type StatusTone = 'default' | 'secondary' | 'destructive' | 'outline';

/**
 * `skipped_*` is `outline` rather than `destructive` because a skip is usually the
 * system working: you muted it, you caused it, it was rolled into a summary. Painting
 * those red would train people to ignore the colour that means a send actually failed.
 */
export function statusTone(status: string): StatusTone {
  if (status === 'sent') return 'default';
  if (status === 'failed' || status === 'destination_gone') return 'destructive';
  if (status.startsWith('skipped')) return 'outline';
  return 'secondary';
}

export const CHANNEL_LABELS: Partial<Record<string, string>> = {
  in_app: 'In-app',
  email: 'Email',
  push: 'Push',
  webhook: 'Webhook',
  slack_webhook: 'Slack',
  teams_webhook: 'Teams',
};

/** The router's category keys, as a reader would say them. */
export const CATEGORY_LABELS: Partial<Record<string, string>> = {
  incidents: 'Incidents',
  approvals: 'Approvals',
  assigned: 'Assigned to me',
  change_problems: 'Change problems',
  activity: 'Activity',
  comments: 'Comments',
  system: 'System',
  reports: 'Reports',
};
